module.exports = require("sitewhere-ide-components");